import axios from "axios";
import { generateXToken } from "@/utils/methods/generateXToken";
import {
  getCartConfigSession,
  getSSIPSession,
  getUserSessionId,
} from "@/utils/methods/getDataFromBrowser";

/*
Example usage:

export const uploadKyc = (formData) => {
  return axiosClient.post("api/user/kyc/upload", {
    inputData: Object.fromEntries(formData),
  });
};


axiosClient.post("<endpoint>", {
  inputData: { ...your parameters... }
});

axiosClient("api/store/pagecontent", {
  data: { inputData: { page: "Profile" } }
});

*/


const axiosClient = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL, 
  method: "post",
});


axiosClient.interceptors.request.use(async (config) => {
  const unixTimestamp = Math.floor(Date.now() / 1000);

  // Always ensure method
  config.method = (config.method || "post").toLowerCase();

  // Fresh headers per request (session can change)
  config.headers = {
    ...(config.headers || {}),
    Ssip: getSSIPSession() || "",
    Cartconfig: JSON.stringify(getCartConfigSession()) || "",
    Appname: import.meta.env.VITE_APP_NAME,
    Usrid: getUserSessionId() || "",
    lng: 'rjs'
  };

  if(config.method !== "post") {
    config.method = "post";
  }

  if (config.method === "post") {
    const originalBody = config.data || {};
    const inputData = originalBody.inputData || {};

    const requestBody = {
      inputData,
      t: unixTimestamp,
    };

    config.data = requestBody;
    config.headers["X-Token"] = await generateXToken(requestBody);
  }

  return config;
});

export default axiosClient;
